import React, { Fragment } from 'react';
import useRawValue from './hooks/useRawValue';
import { JsonEditor } from 'json-edit-react';
import LoadingScreen from '../LoadingScreen';
import RawDisplayValue from '../RawValueDisplay';
import VgsInputLabel from '../VgsInput/VgsInputLabel';

export default function JsonTokenDisplay({
  token,
  label,
}: {
  token: string;
  label: string;
}): React.JSX.Element {
  const rawValue = useRawValue(token);

  const isValidJson = (str: string): boolean => {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };

  if (rawValue && !isValidJson(rawValue)) {
    return (
      <RawDisplayValue
        label={label}
        value={rawValue}
        useFieldStyling={true}
        scrollY={true}
      />
    );
  } else if (rawValue && isValidJson(rawValue)) {
    return (
      <Fragment>
        <VgsInputLabel label={label} required={false} />
        <JsonEditor
          data={JSON.parse(rawValue)}
          restrictAdd={true}
          restrictDelete={true}
          restrictDrag={true}
          restrictEdit={true}
          rootName={' '}
        />
      </Fragment>
    );
  } else {
    return <LoadingScreen />;
  }
}
